module.exports = __webpack_public_path__ + "static/img/empty.d56d8d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/record/empty.png
// module id = Qgqv
// module chunks = 1